/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const EntryListingsFragment = {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  EntryListings: gql`
    fragment EntryListingsQuery on entryListings_Entry {
      typeHandle
      styles
      entryListingsTitle
      stateFilterTitle
      categoryFilterTitle
    }
  `,
};

/**
 * Standalone query for fetching blog entries with pagination.
 * Used by EntryListings component to load blog data on-demand.
 */
export const EntryListingsBlogQuery = {
  name: 'EntryListingsBlogQuery',
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  query: gql`
    query (
      $site: [String]
      $limit: Int
      $offset: Int
      $blogCategories: [QueryArgument]
      $blogStateCategory: [QueryArgument]
    ) {
      entryData: entries(
        site: $site
        section: "pageEntries"
        pageType: "blog"
        limit: $limit
        offset: $offset
        orderBy: "postDate desc"
        blogCategories: $blogCategories
        pageState: $blogStateCategory
      ) {
        dateCreated
        dateUpdated
        postDate
        siteId
        slug
        title
        ... on visionTemplateEntry_Entry {
          blogCategories {
            ... on blogCategories_Category {
              slug
              title
            }
          }
          blogSummary
          featuredEntryImage {
            ... on images_Asset {
              url
              altText
            }
          }
          pageState
          pageType
        }
      }
      entryCount(
        site: $site
        section: "pageEntries"
        pageType: "blog"
        blogCategories: $blogCategories
        pageState: $blogStateCategory
      )
      blogCategories: categories(group: "blogCategories", site: $site, status: "enabled") {
        ... on blogCategories_Category {
          id
          title
          slug
        }
      }
      blogStateCategory: categories(group: "blogStateCategory", site: $site, status: "enabled") {
        ... on blogStateCategory_Category {
          id
          title
          slug
        }
      }
    }
  `,
};
